import { env } from "../../../config/env";
import { apiClient } from "../../config";
import {
    AdminSettings,
    AdminSettingsResponse,
} from "../../interface/admin_settings.interface";
import {
    UpdateAdminSettingsPayload,
    UpdateAdminSettingsResponse,
} from "../../interface/admin_settings.interface";

/**
 * ⚙️ ADMIN SETTINGS SERVICE
 */

class AdminSettingsService {
    /**
     * 📥 GET SETTINGS
     */
    async getSettings(): Promise<AdminSettings> {
        const response = await apiClient.get<AdminSettingsResponse>(
            env.ADMIN_SETTINGS_URL
        );

        return response.data.data.settings;
    }

    /**
     * ✏️ UPDATE SETTINGS (JSON)
     */
    async updateSettings(
        data: UpdateAdminSettingsPayload
    ): Promise<string> {
        const response = await apiClient.put<UpdateAdminSettingsResponse>(
            env.ADMIN_SETTINGS_UPDATE_URL,
            data
        );

        return response.data.message;
    }

    /**
     * 🖼️ UPLOAD MEDIA (multipart/form-data)
     */
    async uploadMedia(files: {
        logo?: File;
        logo_dark?: File;
        favicon?: File;
        cover_image?: File;
        hero_image?: File;
        og_image?: File;
    }): Promise<string> {
        const formData = new FormData();

        Object.entries(files).forEach(([key, file]) => {
            if (file) {
                if (file) formData.append(key, file);
            }
        });

        const response = await apiClient.post(
            env.ADMIN_SETTINGS_MEDIA_URL,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return response.data.message;
    }
}

/**
 * Export instance
 */
export const adminSettingsService = new AdminSettingsService();